import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Alert from 'react-s-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
//components
import ConfirmTable from './ConfirmTable';
import PopupVerify from './PopupVerify';
import OrdersTable from './OrdersTable';
import CustomAlert from '../CustomAlert';
import CustomErrorAlert from '../CustomErrorAlert';
import PageWithSidebar from '../Layouts/PageWithSidebar';
import printDocument from '../../printDocument';
import PopUp from '../UI_Elements/Forms/PopUp';
//other
import Config from '../../config';
import { isWheelChanger, isHarbour, isStation, getHolidays, formatDate } from '../../helpers';
import sv from 'date-fns/locale/sv';
import { registerLocale } from 'react-datepicker';

registerLocale('sv', sv);

moment.tz.setDefault('Europe/Stockholm');
moment.locale('sv');

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class Orders extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      ordersToPrint: [],
      info: [],
      dateCapacity: [],
      startDate: moment(),
      desiredDate: '',
      lastSaved: '',
      ordersToConfirm: [],
      showPopup: false,
      sending: false,
      orderComment: '',
      showConfirmPalete: false,
      confirmPaleteAction: null,
      deliveryDate: 2,
    };

    this.handleChange = this.handleChange.bind(this);
    this.isWeekday = this.isWeekday.bind(this);
    this.updateOrders = this.updateOrders.bind(this);
    this.getOrdersToConfirm = this.getOrdersToConfirm.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.handleDatePickerFocus = this.handleDatePickerFocus.bind(this);
    this.renderDateCapacity = this.renderDateCapacity.bind(this);
    this.updateOrderList = this.updateOrderList.bind(this);

    this.desiredDate = React.createRef();

    this.holidaysArray = getHolidays();
  }

  updateOrders() {
    this.getSavedOrder();
    this.getOrdersToConfirm();
  }

  componentDidMount() {
    this.updateOrders();
  }

  getOrdersToConfirm() {
    var x = null;

    axios
      .get(
        Config.api.getDomain() +
          'order/ordersToConfirm?statuses=3&statuses=5&wheelChangerId=' +
          Config.api.getWheelChangerId(),
        Config.api.getConfig()
      )
      .then((res) => {
        var orders = res.data.map((order) => {
          let pickedDate = null;
          if (parseInt(order.status, 10) === 3) {
            if (order.order.wheelOrders) {
              for (x in order.order.wheelOrders) {
                if (parseInt(order.order.wheelOrders[x].status, 10) === 3) {
                  pickedDate = moment(order.order.wheelOrders[x].updated).format('YYYY-MM-DD');
                  break;
                }
              }
            }
          }

          const newOrder = {
            regNo: order.wheel.regNo,
            orderNr: order.order.id,
            wheeltype: order.wheel.wheeltype.name,
            orderdate: moment(order.order.desiredDate).format('YYYY-MM-DD'),
            comment: order.order.orderComment,
            orderId: order.order.id,
            wheelOrderId: order.id,
            carModel: order.wheel.carModel,
            fromLocationType: order.order.fromLocationType,
            status: order.status,
            pickedDate: pickedDate,
            trackingId: order.trackingId,
          };

          return newOrder;
        });

        this.setState({ ordersToConfirm: orders });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getSavedOrder() {
    const parameters = {
      headers: Config.api.getConfig().headers,
      params: {
        wheelChangerId: Config.api.getWheelChangerId(),
      },
    };
    axios
      .get(Config.api.getDomain() + 'order/saved', parameters)
      .then((res) => {
        var orders = [];

        if (res.data.length > 0) {
          res.data.forEach((order) => {
            const newOrder = {
              regnr: order.wheel.regNo,
              serienr: order.wheel.waggonNo,
              bilmodell: order.wheel.carModel,
              hjulmodell: order.wheel.wheeltype.name,
              offRentDate: order.wheel.offRentDateTime,
              lastOnRentDate: order.wheel.lastOnRentDate,
              id: order.wheel.id,
              valid: true,
              errorMsg: '',
            };
            orders.push(newOrder);
          });

          this.setState(
            {
              orders,
              lastSaved: moment(res.data[0].updated).format('YYYY-MM-DD - HH:mm'),
            },
            () => {}
          );
        } else {
          this.setState({
            orders: [],
            lastSaved: '',
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  deleteRow(order) {
    const parameters = {
      headers: Config.api.getConfig().headers,
      params: {
        wheelId: order.id,
        wheelChangerId: Config.api.getWheelChangerId(),
        wheelStatus: Config.api.getStationType() === 'Harbour' ? 4 : 3,
      },
    };

    const apiCall =
      Config.api.getStationType() === 'Harbour' ? 'deleteHarbourOrder' : 'deleteStationOrder';

    this.setState({
      orders: this.state.orders.filter((o) => {
        return o.regnr !== order.regnr;
      }),
    });
    if (order.valid) {
      axios
        .delete(Config.api.getDomain() + 'wheelOrder/' + apiCall, parameters)
        .then((res) => {
          this.updateOrders();
        })
        .catch((error) => {
          console.log(error);
          console.log('Fel: Ordern hittades inte.');
        });
    }
  }

  isWeekday(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  }

  togglePopup(event) {
    this.setState({
      showPopup: !this.state.showPopup,
    });
  }

  handleRowAdd(event) {
    let regNr = event.regNr;
    let serieNr = event.serieNr;

    const parameters = {
      headers: Config.api.getConfig().headers,
      params: {
        regNo: regNr,
        waggonNo: serieNr,
      },
    };

    axios
      .get(Config.api.getDomain() + 'wheel/order', parameters)
      .then((res) => {
        const order = res.data;

        var newOrder = {
          regnr: event.regNr,
          serienr: event.serieNr,
          bilmodell: order.carModel,
          hjulmodell: order.wheeltype.name,
          offRentDate: order.offRentDate,
          lastOnRentDate: order.lastOnRentDate,
          id: order.id,
        };

        this.state.orders.push(newOrder);
        this.setState(this.state.orders);
      })
      .catch((error) => {
        console.log(error);
        console.log('Fel: Ordern hittades inte.');
      });
  }

  handleChange(e, ref) {
    this.setState({
      [ref.current.input.name]: e,
    });
  }

  handleSave = (event) => {
    event.preventDefault();
    this.setState({ lastSaved: moment().format('YYYY-MM-DD - HH:mm') });
  };

  getInfo() {
    this.setState({ loading: true }, () => {
      axios
        .get(
          Config.api.getDomain() + 'order/info?wheelChangerId=' + Config.api.getWheelChangerId(),
          Config.api.getConfig()
        )
        .then((res) => {
          this.setState({ info: res.data });
          this.togglePopup();
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    var desiredDate, fromLocation;
    desiredDate = this.state.desiredDate;
    if (event.target.name === 'send-order') {
      fromLocation = 3;
    }

    var order = {
      desiredDate: moment(desiredDate).format(),
      fromLocationId: 0,
      fromLocationType: Config.api.getStationType() === 'Harbour' || fromLocation === 2 ? 2 : 3,
      toLocationId: Config.api.getWheelChangerId(),
      toLocationType: 1,
      orderComment: this.state.orderComment,
    };

    if (event.target.name === 'confirm-order') {
      this.setState({
        ordersToPrint: this.state.orders,
      });

      this.setState(
        {
          sending: true,
        },
        () => {
          axios
            .post(Config.api.getDomain() + 'order/create', order, Config.api.getConfig())
            .then((response) => {
              if (response.data.success) {
                this.togglePopup();
                Alert.info(
                  <CustomAlert
                    info={{
                      ...this.state.info,
                      ordersToPrint: this.state.ordersToPrint,
                      desiredDate: desiredDate,
                      pdfType: 'order',
                    }}
                    print={printDocument}
                  />,
                  {
                    timeout: 'none',
                  }
                );
                this.updateOrders();
              } else {
                Alert.info(
                  <CustomErrorAlert
                    error={{
                      message: response.message,
                      desiredDate: desiredDate,
                    }}
                  />,
                  {
                    timeout: 'none',
                  }
                );
              }
              this.setState({
                sending: false,
              });
            })
            .catch((error) => {
              let message = error.response.data.message;
              Alert.info(
                <CustomErrorAlert
                  error={{
                    message: message,
                    desiredDate: desiredDate,
                  }}
                />,
                {
                  timeout: 'none',
                }
              );
              this.setState({
                sending: false,
                showPopup: false,
              });
            });
        }
      );
    } else {
      if (this.state.orders.length > 0 && this.state.desiredDate !== '') this.getInfo();
    }
  };

  handleCommentChange(e) {
    this.setState({ orderComment: e.target.value });
  }

  checkPalletCount(e) {
    const { orders } = this.state;
    if (e.target.name === 'send-order') {
      if (orders.length % 3 !== 0) {
        this.setState({
          showConfirmPalete: true,
        });
      } else {
        this.setState({
          showConfirmPalete: false,
        });
        this.onPopupActionAccept(e);
      }
    }
  }

  onPopupActionCancel(e) {
    this.setState({
      showConfirmPalete: false,
    });
  }

  onPopupActionAccept(e, action) {
    this.setState({
      showConfirmPalete: false,
    });
    this.handleSubmit(e);
  }

  onMonthChange(date) {
    const period = this.getDateFromAndToDate(date);
    this.callApi(period);
  }

  getDateFromAndToDate(date) {
    let previousMonth = moment(date).subtract(1, 'months');
    let upcomingMonth = moment(date).add(1, 'months');
    let firstDate = previousMonth.startOf('month').format('YYYY-MM-DD');
    let endDate = upcomingMonth.endOf('month').format('YYYY-MM-DD');

    return {
      firstDate,
      endDate,
    };
  }

  handleDatePickerFocus(e, ref) {
    e.preventDefault();
    const period = this.getDateFromAndToDate(new Date());
    if (!isHarbour()) {
      this.callApi(period);
    }
  }

  callApi(period) {
    const wheelOrders = this.state.orders.length;
    const wheelChangerId = Config.api.getWheelChangerId();
    const params = {
      headers: Config.api.getConfig().headers,
      params: {
        fromDate: period.firstDate,
        toDate: period.endDate,
        wheelOrders: wheelOrders,
        wheelChangerId: wheelChangerId,
      },
    };
    this.setState({ sending: true }, () => {
      axios
        .get(Config.api.getDomain() + 'order/deliverySchedule', params)
        .then((res) => {
          const capacityData = res.data;
          this.setState({
            dateCapacity: capacityData,
          });
        })
        .catch((error) => {
          console.log(error);
          console.log('Fel: Går ej att hitta kapacitet');
        });
      this.setState({
        sending: false,
      });
    });
  }

  handleDateChangeRaw(e) {
    e.preventDefault();
  }

  getMinDate() {
    if (isHarbour()) {
      let daysToSkip = 3;
      var result = new Date();
      result.setDate(result.getDate() + daysToSkip);
      return result;
    }
  }

  renderDateCapacity(dayOfMonth, date) {
    const theDate = this.state.dateCapacity.find(
      (dc) => formatDate(new Date(dc.date)) === formatDate(date)
    );
    if (theDate) {
      const isWeekend = new Date(theDate.date).getDay() % 6 === 0;
      const today = new Date();
      const isToday = formatDate(today) === formatDate(date);
      const holidays = this.holidaysArray.map((date) => formatDate(new Date(date)));
      const isPublicHolidays = holidays.includes(formatDate(date));
      const isDisabled =
        !theDate.isOrderable ||
        (theDate.freeReservations === 0) & (theDate.orderLimit === 250) ||
        isPublicHolidays ||
        isWeekend;

      return (
        <div
          style={{
            color: isDisabled && !isToday ? '#ccc' : '',
            cursor: isDisabled ? 'default' : '',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <span> {dayOfMonth} </span>
          {!isWeekend && !isPublicHolidays && !isHarbour() && (
            <span style={{ fontWeight: '400' }}>
              {theDate.orderLimit - theDate.freeReservations}/{theDate.orderLimit}
            </span>
          )}
        </div>
      );
    } else {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span> {dayOfMonth} </span>
        </div>
      );
    }
  }

  updateOrderList(newOrders, shouldUpdate) {
    if (shouldUpdate) {
      this.setState({ orders: [...newOrders] });
    } else {
      this.setState({ orders: [...this.state.orders, ...newOrders] });
    }
  }

  render() {
    let orderItemsCount = '';
    if (this.state.orders.length > 0) {
      orderItemsCount = ' (' + this.state.orders.length + ')';
    }

    const holidays = this.holidaysArray.map((date) => formatDate(new Date(date)));
    const disabledDateCalendar = this.state.dateCapacity
      .filter((dc) => !dc.isOrderable || holidays.includes(formatDate(new Date(dc.date))))
      .map((dc) => new Date(dc.date));

    const ordersTable = (
      <div>
        <h2> Gör beställningar </h2>
        <form>
          <OrdersTable
            onRowDel={this.deleteRow.bind(this)}
            onRowAdd={this.handleRowAdd.bind(this)}
            orders={this.state.orders}
            updateOrders={this.updateOrders}
            updateOrderList={this.updateOrderList}
          />
          <div className="order-actions-container">
            <div className="how-many-wheels-bubble">
              <div> Nu har du </div>
              <span className="how-many-wheels">
                {this.state.orders.length}
                av max 42
              </span>
              hjulset.
            </div>
            <div className="datepicker">
              {this.state.sending === false ? (
                <DatePicker
                  name="desiredDate"
                  ref={this.desiredDate}
                  placeholderText="Önskat leveransdatum"
                  selected={this.state.desiredDate !== '' ? this.state.desiredDate : null}
                  onFocus={(e) => {
                    this.handleDatePickerFocus(e, this.desiredDate);
                  }}
                  onChange={(e) => {
                    this.handleChange(e, this.desiredDate);
                  }}
                  dateFormat="yyyy-MM-dd"
                  minDate={this.getMinDate()}
                  excludeDates={disabledDateCalendar}
                  onMonthChange={this.onMonthChange.bind(this)}
                  calendarStartDay={1}
                  autoComplete="off"
                  locale="sv"
                  onChangeRaw={(e) => this.handleDateChangeRaw(e)}
                  renderDayContents={this.renderDateCapacity}
                />
              ) : (
                <DatePicker placeholderText="Laddar datum..." />
              )}
            </div>
            {this.state.lastSaved !== '' && (
              <div className="latest-saved--container">
                <div className="latest-saved">
                  Senast sparad:
                  <br /> {this.state.lastSaved}
                </div>
              </div>
            )}
            <input
              type="button"
              name="send-order"
              className="btn yellow send-order-btn"
              value={'Skicka beställning' + orderItemsCount}
              disabled={
                this.state.orders.length > 0 && this.state.desiredDate !== '' ? false : true
              }
              onClick={(e) => this.checkPalletCount(e)}
            />
            <input
              type="button"
              name="clear-erros"
              className="btn yellow send-order-btn"
              value={'Ta bort alla felaktiga hjul'}
              style={{ marginLeft: '20px' }}
              disabled={
                this.state.orders.some((order) => order.serienr.length > 0 && !order.valid)
                  ? false
                  : true
              }
              onClick={() => this.updateOrders()}
            />
          </div>
        </form>
        {this.state.showConfirmPalete && (
          <PopUp
            onCancel={(event) => this.onPopupActionCancel(event)}
            onAccept={(event) => this.onPopupActionAccept(event)}
            title={
              'Är du säker på att du vill genomföra beställningen eller kan du lägga till ' +
              'uppsättning/uppsättningar för att optimera transportkostnaden?'
            }
          >
            <p>
              Beställning är inte jämt delbart med 3 vilket påverkar transportkostnaden(Det får
              plats 3 hjul - set per pall).Är du säker på att du vill genomföra beställningen eller
              kan du lägga till uppsättning / uppsättningar för att optimera transportkostnaden ?
            </p>
          </PopUp>
        )}
      </div>
    );

    const ordersFromStation = this.state.ordersToConfirm.filter((order) => {
      return order.fromLocationType === 1;
    });

    const ordersFromWheelDistributor = this.state.ordersToConfirm.filter((order) => {
      return order.fromLocationType === 2;
    });

    const ordersFromWareHouse = this.state.ordersToConfirm.filter((order) => {
      return order.fromLocationType === 3;
    });

    var ordersToConfirm = this.state.orders;

    return (
      <PageWithSidebar page={'orders'} location={this.props.location}>
        <h1> Beställningar </h1> {!isWheelChanger() && ordersTable}
        {(isHarbour() || isStation()) && (
          <ConfirmTable
            ordersToConfirm={ordersFromWheelDistributor}
            updateOrders={this.updateOrders}
            showPickedDate={true}
            showSendBackBtn={true}
            title="Mottagningsbekräfta - Goodyear"
          />
        )}
        {!isHarbour() && (
          <ConfirmTable
            ordersToConfirm={ordersFromWareHouse}
            updateOrders={this.updateOrders}
            showPickedDate={true}
            showSendBackBtn={true}
            title="Mottagningsbekräfta - Centrallager"
          />
        )}
        {ordersFromStation.length > 0 && (
          <ConfirmTable
            hidePreferedDate={true}
            ordersToConfirm={ordersFromStation}
            updateOrders={this.updateOrders}
            showPickedDate={true}
            showSendBackBtn={false}
            title="Mottagningsbekräfta - Annan station"
          />
        )}
        {this.state.showPopup && (
          <PopupVerify
            data={ordersToConfirm}
            info={this.state.info}
            toggleNext={this.toggleNext}
            closePopup={this.togglePopup}
            submit={this.handleSubmit}
            sending={this.state.sending}
            handleCommentChange={this.handleCommentChange}
          />
        )}
      </PageWithSidebar>
    );
  }
}

/**
 * Map actions to properties
 */
const mapDispatchToProps = (dispatch) => {
  return {
    Orders: () => dispatch(Orders()),
  };
};

/**
 * Export Edit Employee
 */
export default connect(null, mapDispatchToProps)(Orders);



// WEBPACK FOOTER //
// ./src/components/Orders/index.js